import { Layout, Spin } from 'antd';

const AuthLoading: React.FC = () => (
  <Layout className="min-h-screen flex items-center justify-center">
    <Spin />
    Loading Profile...
  </Layout>
);

export default AuthLoading;
